var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPickupNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.36783 7.03195C3.66636 7.33052 4.16048 7.33052 4.45901 7.03195L6.2296 5.26109L6.2296 10.6045C6.2296 11.0267 6.5796 11.3767 7.00165 11.3767C7.42371 11.3767 7.77371 11.0267 7.77371 10.6045L7.77371 5.26109L9.5443 7.03195C9.84283 7.33052 10.3369 7.33052 10.6355 7.03195C10.934 6.73337 10.934 6.23918 10.6355 5.94061L7.54724 2.8519C7.39283 2.69747 7.19724 2.6254 7.00165 2.6254C6.80607 2.6254 6.61048 2.69747 6.45607 2.8519L3.36783 5.94061C3.0693 6.23918 3.0693 6.73337 3.36783 7.03195Z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupNew);
export default __webpack_public_path__ + "static/media/pickup_new.2fdc86dcddc0f5842478525083f6386e.svg";
export { ForwardRef as ReactComponent };